import { Tooltip } from "@mui/material";
import dayjs from "dayjs";

const BonusCard = (props) => {
  //console.log(props.cardData);
  const {minimum_loan_amount,maximum_loan_amount,payout_days,name,endDate,startDate,bonus,bonus_type,bonus_distribution_period} = props.cardData;
  let formatedStartDate = dayjs(startDate).format("DD MMM YYYY").toUpperCase();
  let formatedEndDate = dayjs(endDate).format("DD MMM YYYY").toUpperCase();
  let bonDisPeriod='';
  switch(bonus_distribution_period){
    case 'weekly':
      bonDisPeriod = 'Calendar Week';
      break;
    case 'monthly':
      bonDisPeriod = 'Calendar Month';
      break;
    case 'quarterly':
      bonDisPeriod = 'Calendar Quarter';
      break;
    case 'half-yearly':
      bonDisPeriod = 'Calendar Half';
      break;
    case 'yearly':
      bonDisPeriod = 'Calendar Year';
      break;
    default:
      break;
  }
  return (
    <div className="w-full mb-[15px] max-[450px]:flex-col max-w-full bg-white rounded-[8px] border border-[#E0E0E0] flex overflow-hidden relative">
      <div className="bg-[#0E085C] text-white flex flex-wrap items-center justify-center gap-[15px] relative w-[310px] max-w-full flex-shrink-0 max-[450px]:w-full max-[450px]:py-[20px]">
        <div className="absolute top-[8px] left-[8px]">
          <Tooltip title="coming soon">
            <img
              src="/images/fi_info_wh.svg"
              alt="info"
              className="inline-block ml-[8px]"
            />
          </Tooltip>
        </div>
        <div className="flex flex-col items-center justify-center flex-shrink-0">
            <span className="text-[11px] font-[500]">Tier 1</span>
            <h3 className="font-[300] text-[16px] leading-[25px] tracking-[-1px]">
              {props?.cardData?.qualifying_loan_amounts !== null &&
                props?.cardData?.qualifying_loan_amounts?.slice(0,1).map(
                  (item, index) =>
                    <span className="font-[600]">
                      {item.bonus_type === 2 && '$ '}
                      {item?.bonus} 
                      {item.bonus_type === 1 && ' %'}
                    </span>
                )}
            </h3>
            <span className="text-[10px] font-[400]">Bonus Amount</span>
        </div>
        {props?.cardData?.qualifying_loan_amounts !== undefined &&
          props?.cardData?.qualifying_loan_amounts.length > 1 && (
            <div className="flex-shrink-0 border-l border-white text-[12px] pl-[15px]">
              {
                props?.cardData?.qualifying_loan_amounts.slice(1).map((item,idx)=>{
                  return(
                    <div className="mb-[10px] last:mb-[0]">
                      <div>Tier {idx+2}: {item.bonus_type === 2 && '$'}{item?.bonus}{item.bonus_type === 1 && '%'}</div>
                      <div>${item?.minimum_loan_amount} to ${item?.maximum_loan_amount}</div>
                    </div>
                  )
                })
              }
            </div>
          )
        }
      </div>
      <div className="p-[17px_27px_3px_27px] flex-[1]">
        <h3 className="text-[#27272B] text-[14px] font-[700] mb-[14px] flex items-center justify-between">{name}
        </h3>
        <div className="flex flex-wrap items-center justify-between gap-[15px_30px] mb-[14px]">
          <div>
            <label className="text-[#787486] text-[13px] block mb-[5px]">Bonus Program Valid Period</label>
            <p className="flex items-center mb-[0] text-[#0F0F0F] font-[500] text-[13px]">
              <img src="/images/fi_calendar.svg" alt="calendar" className="mr-[5px]" />
              {formatedStartDate}   <span className="mx-[7px]">to</span>  {formatedEndDate}
            </p>
          </div>
          <div>
            <label className="text-[#787486] text-[13px] block mb-[5px]">Qualifying loan amount</label>
            {props.cardData?.qualifying_loan_amounts !== null && props.cardData?.qualifying_loan_amounts !== undefined &&
              props.cardData?.qualifying_loan_amounts?.slice(0,1).map((item,idx) => (
                <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px] mb-[2px]">
                  <span className="inline-block">${item?.minimum_loan_amount}{" "}</span>
                  <span className="mx-[7px]">to</span> 
                  <span className="inline-block"> ${item?.maximum_loan_amount}</span>
                </p>
              ))}
          </div>
          <div>
            <label className="text-[#787486] text-[13px] block mb-[5px]">Qualifying period & Payout</label>
            <p className="text-[#0F0F0F] mb-[0] font-[500] text-[13px]">{bonDisPeriod} payout within {payout_days} days after end of qualifying period</p>
          </div>
        </div>
      </div>
    </div>
  )
};

export default BonusCard;
